import { User } from '../@types/users';

export const shouldFilterUserByQuery = (user: User, query: string): boolean => {
  if (!query || !query.trim()) {
    return true;
  }

  const trimmed = query.trim().toLowerCase();
  const firstName = (user.firstName || '').toLowerCase();
  const lastName = (user.lastName || '').toLowerCase();
  const fullName = `${firstName} ${lastName}`.trim();
  const reverseFullName = `${lastName} ${firstName}`.trim();
  const username = (user.username || '').toLowerCase();

  if (
    firstName.includes(trimmed) ||
    lastName.includes(trimmed) ||
    fullName.includes(trimmed) ||
    reverseFullName.includes(trimmed) ||
    username.includes(trimmed)
  ) {
    return true;
  }

  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length > 1) {
    return words.every(
      (word) =>
        firstName.includes(word) ||
        lastName.includes(word) ||
        username.includes(word),
    );
  }

  return false;
};
